import React from 'react';
import { Table } from 'semantic-ui-react';
import { columnTools, hasColumn } from '@/constants/fields';
import DatasetToolsMenu from '../containers/DatasetToolsMenu';
import DatasetRowWrapper from './DatasetRowWrapper';

const DatasetRow = ({
  className,
  columns = [],
  dataset,
  onCheckBoxClick,
  selectable,
  theme,
  upward,
}) => ((
  <DatasetRowWrapper
    className={className}
    columns={columns}
    dataset={dataset}
    onCheckBoxClick={onCheckBoxClick}
    selectable={selectable}
    theme={theme}
  >
    {hasColumn(columns, columnTools) && (
    <Table.Cell collapsing><DatasetToolsMenu upward={upward} dataset={dataset} /></Table.Cell>
    )}
  </DatasetRowWrapper>
));

export default DatasetRow;
